/* hs-eslint ignored failing-rules */

import { useMutation } from 'data-fetching-client';
import emptyFunction from 'react-utils/emptyFunction';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import { UPDATE_FLOW_TEAM_ASSIGNMENT } from 'automation-ui-management/queries/flowQueries';
import Scopes from 'automation-ui-management/constants/Scopes';
import AllTeamAssetAccessPanel from 'automation-ui-management/components/panels/AllTeamAssetAccessPanel';
import UserTeamAssetAccessPanel from 'automation-ui-management/components/panels/UserTeamAssetAccessPanel';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
import { jsx as _jsx } from "react/jsx-runtime";
const TeamAssetAccessPanelWrapper = ({
  assetTypeDisplayName,
  assignedTeamIds,
  flowId,
  onClosePanel,
  onFailure = emptyFunction,
  onSuccess = emptyFunction
}) => {
  const hasViewAllScope = useHasScope(Scopes.WORKFLOWS_VIEW_ALL);
  const [updateFlowTeamAssignment, {
    loading
  }] = useMutation(UPDATE_FLOW_TEAM_ASSIGNMENT, {
    onCompleted: () => {
      onSuccess(assignedTeamIds);
      onClosePanel();
    },
    onError: error => {
      onFailure(error);
      onClosePanel();
    }
  });
  const handleUpdateFlowTeamAssignment = ({
    selectedTeamIds
  }) => {
    updateFlowTeamAssignment({
      variables: {
        flowId,
        teamIds: selectedTeamIds
      }
    }).catch(error => {
      reportError({
        error
      });
    });
  };
  if (hasViewAllScope) {
    return /*#__PURE__*/_jsx(AllTeamAssetAccessPanel, {
      assetTypeDisplayName: assetTypeDisplayName,
      assignedTeamIds: assignedTeamIds,
      onSave: handleUpdateFlowTeamAssignment,
      onCancel: onClosePanel,
      showSaveLoading: loading
    });
  }
  return /*#__PURE__*/_jsx(UserTeamAssetAccessPanel, {
    assetTypeDisplayName: assetTypeDisplayName,
    assignedTeamIds: assignedTeamIds,
    onSave: handleUpdateFlowTeamAssignment,
    onCancel: onClosePanel,
    showSaveLoading: loading
  });
};
export default TeamAssetAccessPanelWrapper;